import React, { JSX } from 'react'
import Navigation from '@App/navigation'
import { BulkUploadErrorType } from '@App/enum/bulk-upload-error-type'

const bulkErrorStrings: Record<
    BulkUploadErrorType,
    { header: string; subheader: string; errorBody: string | JSX.Element | undefined; footer: string }
> = {
    [BulkUploadErrorType.UNKNOWN]: {
        errorBody: (
            <>
                Please contact The MLC Support Team <a href={Navigation.contactUs.root()}>here</a> to resolve this
                issue.
            </>
        ),
        footer: '',
        header: 'Something has gone wrong',
        subheader: '',
    },
    [BulkUploadErrorType.PARSE_ERROR]: {
        errorBody: (
            <>
                Please contact The MLC Support Team <a href={Navigation.contactUs.root()}>here</a> to resolve this
                issue.
            </>
        ),
        footer: '',
        header: 'There is a formatting error with your file',
        subheader: '',
    },
    [BulkUploadErrorType.DUPLICATE_TITLE]: {
        errorBody:
            "For multiple writers on the same work, completely fill in all necessary columns including the first writer's information. " +
            'Then move to the row below, leave columns A-F blank, and begin the second writer&apos;s info in column G, continuing until all writers are entered.',
        footer: 'Once you have resolved this error, please upload again.',
        header: 'Unique work titles can only appear once per bulk work upload file',
        subheader: '',
    },
    [BulkUploadErrorType.REQUIRED]: {
        errorBody: undefined,
        footer: 'Please check your bulk work file and ensure that all required fields are filled out. Once resolved, please try again.',
        header: 'It looks like some information is missing or incorrect',
        subheader: 'There are required fields in your file that appear to be empty or have incorrect data.',
    },
    [BulkUploadErrorType.FILE_TOO_LARGE]: {
        header: 'Your file is too large',
        subheader: 'At this time, we can accept files with up to 300 lines.',
        errorBody: undefined,
        footer: 'Please break down your works data into smaller files and try uploading again.',
    },
}
export default bulkErrorStrings
